/* NAO Infinite Scroll v4 – Debut
   - Compatible: collection-template.liquid + collection.ajax.liquid (?view=ajax)
   - Append ONLY <li.nao-collection-item> to avoid page2 layout break
*/
(function () {
  if (!document.body.classList.contains('template-collection')) return;

  var grid =
    document.getElementById('append-data-here') ||
    document.querySelector('#Collection .nao-collection-grid') ||
    document.querySelector('.nao-collection-grid');

  var loadMore = document.getElementById('load-more-products');
  var loader = document.getElementById('infinite-scroll-loader');

  if (!grid || !loadMore) return;

  var isLoading = false;
  var observer = null;

  function ensureAjaxUrl(url) {
    if (!url) return '';
    // Prevent double view params
    if (url.indexOf('view=ajax') !== -1) return url;
    return url + (url.indexOf('?') === -1 ? '?view=ajax' : '&view=ajax');
  }

  function showLoader(on) {
    if (!loader) return;
    loader.style.display = on ? 'block' : 'none';
  }

  async function loadNextPage() {
    if (isLoading) return;

    var rawNext = loadMore.getAttribute('data-next-page');
    if (!rawNext) {
      if (observer) observer.disconnect();
      return;
    }

    var nextUrl = ensureAjaxUrl(rawNext);
    if (!nextUrl) return;

    isLoading = true;
    showLoader(true);

    try {
      var res = await fetch(nextUrl, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('HTTP ' + res.status);

      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');

      // IMPORTANT: on récupère les LI NAO, pas les wrappers
      var newItems = doc.querySelectorAll('li.nao-collection-item');
      if (newItems && newItems.length) {
        newItems.forEach(function (li) {
          // importNode = safe append
          var imported = document.importNode(li, true);
          grid.appendChild(imported);
        });
      }

      // Update next url from the ajax view
      var newLoadMore = doc.getElementById('load-more-products');
      var newNext = newLoadMore ? newLoadMore.getAttribute('data-next-page') : '';

      if (newNext) {
        loadMore.setAttribute('data-next-page', newNext);
      } else {
        loadMore.removeAttribute('data-next-page');
        if (observer) observer.disconnect();
        showLoader(false);
      }

      // Trigger lazyload / theme observers
      window.dispatchEvent(new Event('scroll'));
      window.dispatchEvent(new Event('resize'));
    } catch (e) {
      console.error('[NAO] infinite scroll error', e);
    } finally {
      isLoading = false;
      showLoader(false);
    }
  }

  // Sentinel = loader si dispo, sinon loadMore
  var sentinel = loader || loadMore;

  if ('IntersectionObserver' in window && sentinel) {
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadNextPage();
        });
      },
      { root: null, rootMargin: '900px 0px 900px 0px', threshold: 0.01 }
    );

    observer.observe(sentinel);
  } else {
    window.addEventListener('scroll', function () {
      if (isLoading) return;
      if (window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 900) {
        loadNextPage();
      }
    });
  }
})();
